module.exports = __webpack_public_path__ + "static/media/12_insideyourblood.7c117664.jpg";